import { endOfDay, startOfDay } from "date-fns";
import { is0oClock, isAlmost0oClock } from "../../../../utils/timeUtils";
import { TDailyScheduleEntry } from "../types";
import { TDailyScheduleEntryDto } from "../../../../services/schedulers/types";

export class TDailyScheduleEntryExtensions {

    static fromDtos(items: TDailyScheduleEntryDto[], weekday: number): TDailyScheduleEntry[] {
        if (items.length === 0)
            return [{
                weekday: weekday,
                start: startOfDay(new Date()),
                end: endOfDay(new Date()),
                value: null,
                id: `${weekday}_def_1`,
                isDefault: true
            }]

        const converted: TDailyScheduleEntry[] = items.map((v, j) => ({
            start: new Date(v.start),
            end: new Date(v.end),
            value: v.value,
            weekday: v.weekday,
            id: `${v.weekday}_${j}`,
            isDefault: false
        }))
        const itemsWithEmpty = this.fillEmpty(converted,weekday)
        return itemsWithEmpty;
    }

    static toDtos(entries: TDailyScheduleEntry[]): TDailyScheduleEntryDto[] {
        return entries.filter(x => !x.isDefault).map(v => this.toDto(v));
    }
    static toDto(entry: TDailyScheduleEntry): TDailyScheduleEntryDto {
        return { end: DateToUnspecificDateString(entry.end), start: DateToUnspecificDateString(entry.start), value: entry.value, weekday: entry.weekday }
    }

    static addItem(items: TDailyScheduleEntry[], newItem: TDailyScheduleEntry): TDailyScheduleEntry[] {
        const copy = [...items];
        copy.push({
            start: newItem.start,
            end: newItem.end,
            value: newItem.value,
            weekday: newItem.weekday,
            id: newItem.id,
            isDefault: newItem.isDefault
        })
        return this.fillEmpty(copy,newItem.weekday);
    }

    static updateItem(items: TDailyScheduleEntry[], item: TDailyScheduleEntry) {
        const entry = items.find(x => x.id === item.id);
        if (!entry) throw ("entry not found");
        const entryIndex = items.indexOf(entry);
        if (entryIndex < 0) throw ("entry index not found");

        const copy = [...items];
        copy[entryIndex] = {
            start: item.start,
            end: item.end,
            value: item.value,
            weekday: item.weekday,
            id: item.id,
            isDefault: item.isDefault
        }
        return this.fillEmpty(copy, item.weekday);
    }

    static deleteItem(items: TDailyScheduleEntry[], item: TDailyScheduleEntry) {
        const copy = [...items];
        const entry = copy.find(x => x.id === item.id);
        if (!entry) throw ("entry not found");

        const entryIndex = copy.indexOf(entry);
        copy.splice(entryIndex, 1);

        console.log("deleteItem - result",copy);
        return this.fillEmpty(copy,item.weekday);
    }

    // Declare the Extension Method
    static fillEmpty(items: TDailyScheduleEntry[], weekday: number): TDailyScheduleEntry[] {

        const sorted = [...items].filter(v => !v.isDefault).sort((a, b) => a.start.getTime() - b.start.getTime())
        if ( !sorted || sorted.length === 0)
        {
            const now = new Date();
            return [
                {
                    weekday: weekday,
                    start: startOfDay(now), end: endOfDay(now),
                    value: null,
                    id: `${weekday}_def_${0}`,
                    isDefault: true
                }
            ]
        }

        let defaultCounter = 1;
        let res: TDailyScheduleEntry[] = []
        for (let i = 0; i < sorted.length; i++) {
            const prev = i > 0 ? sorted[i - 1] : undefined;
            const current = sorted[i];
            const startDate = current.start;
            const endDate = current.end;
            const prevEndDate = prev ? prev.end : undefined;

            if (!prev && !is0oClock(startDate))
                res.push({
                    weekday: current.weekday,
                    start: startOfDay(startDate),
                    end: startDate,
                    value: null,
                    id: `${current.weekday}_def_${defaultCounter++}`,
                    isDefault: true
                })
            else if (prevEndDate && startDate.getTime() > prevEndDate.getTime())
                res.push({
                    weekday: current.weekday,
                    start: prevEndDate,
                    end: startDate,
                    value: null,
                    id: `${current.weekday}_def_${defaultCounter++}`,
                    isDefault: true
                })
            // regular item
            res.push({
                id: current.id,
                end: current.end,
                start: current.start,
                value: current.value,
                weekday: current.weekday,
                isDefault: false
            });

            const isLastOne = i === sorted.length - 1;
            if (isLastOne && !isAlmost0oClock(endDate))
                res.push({
                    weekday: current.weekday,
                    start: endDate, end: endOfDay(endDate),
                    value: null,
                    id: `${current.weekday}_def_${defaultCounter++}`,
                    isDefault: true
                })

        }
        return res;
    }
}



const DateToUnspecificDateString = (date: Date) => {
    const time = new Date(date).toTimeString();
    // we need a unspecific date time!
    const start = time.slice(0, time.indexOf(' '));
    const now = new Date();

    return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}T${start}`
}